module.exports = __webpack_public_path__ + "img/approval.512c9d0c.svg";